<app-grid
    [columns]="columns"
    [rows]="data.tableRows"
    [tableParams]="data.tableParams"
    [multiSelect]="false"
    [gridName]="gridName"
    (refreshDataFromServer)="refreshData($event)"
    [allowDelete]="true"
    [allowCopy]="true"
    (copyClicked)="copyCandidateClicked()"
    (rowSelected)="setCandidateData($event)"
    (addClicked)="addCandidateClicked()"
    (editClicked)="editCandidateClicked()"
    (deleteClicked)="deleteCandidateClicked()"
    (exportClicked)="exportCandidateClicked()"

></app-grid>
